import { render, staticRenderFns } from "./Vip.vue?vue&type=template&id=f49b983a&scoped=true"
import script from "./Vip.vue?vue&type=script&lang=js"
export * from "./Vip.vue?vue&type=script&lang=js"
import style0 from "./Vip.vue?vue&type=style&index=0&id=f49b983a&prod&lang=less&scoped=true"
import style1 from "./Vip.vue?vue&type=style&index=1&id=f49b983a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_675154ded190a7e2d3ad9efb69cc05e3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49b983a",
  null
  
)

export default component.exports